import { render, staticRenderFns } from "./t-key-value-data.vue?vue&type=template&id=5c1ebaed&scoped=true&lang=pug"
import script from "./t-key-value-data.vue?vue&type=script&lang=js"
export * from "./t-key-value-data.vue?vue&type=script&lang=js"
import style0 from "./t-key-value-data.vue?vue&type=style&index=0&id=5c1ebaed&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1ebaed",
  null
  
)

export default component.exports